import { LabelOf, ValueOf } from '@xhgj/xh-jsutils'
import { customCreateEnum } from './enumArray'

// 新增采购订单订单类型
export const applyForOrdeTypeList = [
  {
    label: '金蝶采购订单',
    value: '1',
  },
  {
    label: '标准采购',
    value: 'NB',
    shortCn: '标准',
  },
  {
    label: '寄售采购订单',
    value: 'Z040',
    shortCn: '寄售',
  },
  {
    label: '委外加工采购订单',
    value: 'Z010',
    shortCn: '委外加工',
  },
  {
    label: '寄售转自有采购订单',
    value: 'Z070',
  },
  {
    label: '海外采购订单',
    value: 'Z080',
    shortCn: '海外',
  },
  {
    label: '定向采购',
    value: 'DB',
    shortCn: '定向采购',
  },
] as const

export type ApplyForOrdeTypeLabel = LabelOf<typeof applyForOrdeTypeList>
export type ApplyForOrdeTypeValue = ValueOf<typeof applyForOrdeTypeList>

export const applyForOrderTypeEnum = customCreateEnum(applyForOrdeTypeList)
import { LabelOf, ValueOf } from '@xhgj/xh-jsutils'
import { customCreateEnum } from './enumArray'

// 新增采购订单订单类型
export const applyForOrdeTypeList = [
  {
    label: '金蝶采购订单',
    value: '1',
  },
  {
    label: '标准采购',
    value: 'NB',
    shortCn: '标准',
  },
  {
    label: '寄售采购订单',
    value: 'Z040',
    shortCn: '寄售',
  },
  {
    label: '委外加工采购订单',
    value: 'Z010',
    shortCn: '委外加工',
  },
  {
    label: '寄售转自有采购订单',
    value: 'Z070',
  },
  {
    label: '海外采购订单',
    value: 'Z080',
    shortCn: '海外',
  },
  {
    label: '定向采购',
    value: 'DB',
    shortCn: '定向采购',
  },
] as const

export type ApplyForOrdeTypeLabel = LabelOf<typeof applyForOrdeTypeList>
export type ApplyForOrdeTypeValue = ValueOf<typeof applyForOrdeTypeList>

export const applyForOrderTypeEnum = customCreateEnum(applyForOrdeTypeList)
